import { getMeta, getWorkspaceAri, getCloudId } from '@helpcenter/meta';

export const getAggHeaders = () => ({
	'X-B3-TraceId': getMeta('X-B3-TraceId') || '',
	'atl-attribution': JSON.stringify({
		atlWorkspaceId: getWorkspaceAri(),
		tenantId: getCloudId(),
		product: 'Jira',
		service: 'jsm-help-center-ui',
	}),
});
